import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

class BironexPage extends React.Component {
    static contextTypes = {
        footer: React.PropTypes.object
    };

    componentDidMount() {
        if ((!this.props.user && this.props.countryCode !== 'KG') || (this.props.user && this.props.user.get('resourceId') !== 1)) {
            this.props.push('/');
        }
    }

    render() {
        return (
            <div>
                <div className='bironex-modal'>
                    <div className='bironex-modal__block bironex-modal__block--top'>
                        <p>Пополнить баланс и обналичить средства в вашем регионе возможно без комиссии с помощью криптовалюты «Opex» в терминалах «Pay24» и «Bironex». Обменный курс: 1 OPX = 1 У.Е.</p>
                        <p>Подробности и адреса терминалов доступны на <a href='http://bironex.com/' target='_blank'>bironex.com</a></p>
                    </div>
                    <div className='bironex-modal__block'>
                        <div className='bironex-modal__block__title'>
                            Как пополнить
                        </div>
                        <iframe width="760" height="425" src="https://www.youtube.com/embed/IiU8luXXqVg" frameBorder="0" allowFullScreen></iframe>
                    </div>
                    <div className='bironex-modal__block'>
                        <div className='bironex-modal__block__title'>
                            Как обналичить
                        </div>
                        <iframe width="760" height="425" src="https://www.youtube.com/embed/Qs4jonzXyYI" frameBorder="0" allowFullScreen></iframe>
                    </div>
                </div>
                {this.context.footer}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.get('user'),
        countryCode: state.application.get('countryCode')
    }
}

export default connect(mapStateToProps, {push})(BironexPage);


// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/BironexPage.jsx